/**
 * Convert res.json's rows to resource objects using the custom mapping for Profile1.
 * @param row
 */
function mapProfile1ResourceRowToResourceObj(row) {
  return {
    objectId: row[4].toString(),
    code: row[0],
    name: row[1],
    displayOrder: row[3],
    "担当者コード": row[2],
  }
}

/**
 * Convert res.json's rows to resource objects.
 * @param row
 */
function mapResourceRowToResourceObj(row) {
 return {
   objectId: row[3].toString(),
   code: row[0],
   name: row[1],
   displayOrder: row[2],
 }
}

/**
 * Convert table-style data of res.json to array of objects
 * @param {any} resourcesData
 * @param {any} resourceGroupsData
 * @returns {{
 *   resources: {
 *    objectId: string,
 *    code: string,
 *    name: string,
 *    displayOrder: number,
 *   }[],
 *   resourceGroups: {
 *     code: string,
 *     groupMembers: string[], // array of resource codes of the resource's members (if it is a resource group)
 *   }[]
 * }}
 */
export function parseResourcesData(resourcesData, resourceGroupsData) {
  if (!resourcesData) return {resources: [], resourceGroups: []}
  const rows = resourcesData.Rows

  const resources = resourcesData.isCustomized
    ? rows.map(mapProfile1ResourceRowToResourceObj)
    : rows.map(mapResourceRowToResourceObj)
  const resourceCodeToResourceMap = new Map(resources.map(resource => [resource.code, resource]))

  // determine group members
  const resourceGroups = Object.keys(resourceGroupsData ?? {}).map(resourceGroupCode => {
    const groupMemberResourceCodes = resourceGroupsData[resourceGroupCode] ?? []
    return {
      code: resourceGroupCode,
      groupMembers: groupMemberResourceCodes.map(code => resourceCodeToResourceMap.get(code)),
    }
  })

  return {
    resources,
    resourceGroups,
  }
}

export function getResourceNameOrCode(resource) {
  return resource?.name || resource?.code || ""
}

export function sortResourcesByDisplayOrder(resources) {
  const returned = structuredClone(resources)
  returned.sort((a, b) => {
    if (a.displayOrder < b.displayOrder) {
      return -1;
    } else if (a.displayOrder > b.displayOrder) {
      return 1;
    } else {
      return 0;
    }
  })
  return returned
}

/**
 * Read the resource details data and extract rows (operations) and columns
 * @param resourceDetailData
 */
export function parseResourceDetailData(resourceDetailData) {
  const columnKeys = Object.keys(resourceDetailData.Columns)
  const columns = columnKeys
    .filter(key => key !== "MyScheReservedFixedProperty")
    .map(key => ({key, displayedString: resourceDetailData.DisplayedStrings[key] ?? ""}))

  const rows = resourceDetailData.Rows
    .map(row => Object.fromEntries(row.map((cell, index) => [columnKeys[index], cell])))
  return {columns, rows}
}
